<template>
  <div class="header_card"><span class="cardmedia">{{title}}</span><span class="leftx">X</span></div>
</template>
 
<script>
export default {
  name: "CatInput",
  props: {
    title: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "text",
    },
    rtest:{
 type: String,
     default: "",
    },
    name: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: "",
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    showPassword: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
 
    };
  },
  methods: {
   
  },
 
};
</script>
<style lang="less" scoped>
 .header_card{
      color: rgba(0,0,0,1);
    font-size: 36.00px;
    height: 50px;
    line-height: 50px;
    margin: 0 30px;
    position: relative;
}
.cardmedia{
  color: #000000;
  font-size: 36px;
}
.leftx{
  position: absolute;
    left: 0;
    color: #000000;
    font-size: 30.35px;
}

</style>